<template>
  <b-card
    no-body
    class="border-0"
    header-class="px-1 py-2"
    footer-class="p-1">
    <h6 slot="header" class="mb-0">
      <b-button-close @click="hidePopup()"></b-button-close>
      {{params.colDef.headerName}} filter
    </h6>
    <b-button-toolbar slot="footer">

      <b-button
        v-if="isAnyRunSelected"
        size="sm" class="mr-1"
        @click="onToggleSelectAll"
        title="Deselect all scenarios currently selected and shown in the list">
        Deselect all
      </b-button>
      <b-button
        v-else
        size="sm" class="mr-1"
        @click="onToggleSelectAll"
        title="Select all scenarios shown in the list">
        Select all
      </b-button>

      <b-button
        size="sm" class="mr-1"
        :pressed="filter && filter.selected"
        @click="onShowSelected"
        title="Show selected scenarios only">
        Show selected
      </b-button>

      <b-button
        size="sm" class="mr-1"
        :pressed="filter && filter.unselected"
        @click="onHideSelected"
        title="Show all but selected">
        Hide selected
      </b-button>

      <b-button size="sm" @click="onClearFilter">Reset</b-button>

    </b-button-toolbar>
  </b-card>
</template>

<script>
  export default {
    name: 'SelectedFilter',
    data() {
      return {
        params: null,
        hidePopup: null,
        filter: null,
      };
    },
    computed: {
      isAnyRunSelected() {
        const {selectionRunsSet} = this.params.context.parent;
        return selectionRunsSet.length > 0;
      },
    },
    methods: {
      isFilterActive() {
        return this.filter !== null;
      },
      doesFilterPass(params) {
        const {selectionRunsSet} = this.params.context.parent;
        const {selected, unselected} = this.filter;
        const runId = params.data.run_id;
        return !this.filter || (selected && selectionRunsSet.has(runId)) || (unselected && !selectionRunsSet.has(runId));
      },
      getModel() {
        return this.filter;
      },
      setModel(filter) {
        this.filter = filter;
      },
      afterGuiAttached({hidePopup}) {
        this.hidePopup = hidePopup;
      },
      onToggleSelectAll() {
        if (this.params.api.getSelectedNodes().length) {
          this.params.api.forEachNodeAfterFilterAndSort(node => node.setSelected(false));
        } else {
          this.params.api.forEachNodeAfterFilterAndSort(node => node.setSelected(true));
        }
      },
      onShowSelected() {
        this.filter = {selected: true, unselected: false};
        this.params.filterChangedCallback();
        this.hidePopup();
      },
      onHideSelected() {
        this.filter = {selected: false, unselected: true};
        this.params.filterChangedCallback();
        this.hidePopup();
      },
      onClearFilter() {
        this.setModel(null);
        this.params.filterChangedCallback();
        this.hidePopup();
      },
    },
  };
</script>

<style scoped>

</style>
